import { IDestroyOptions, Text } from "pixi.js";
import { LatestNewsResourcePackage } from "../../resources/LatestNewsResourcePackage";
import { INewsItemOptions, NewsItem } from "./NewsItem";
import { NewsTextStyle } from "../styles/NewsTextStyle";
import { TextWithUnderline } from "by/gamefactory/cityversetycoon/scenes/game/components/TextWithUnderline";
import { ILatestNewsController } from "../../controllers/ILatestNewsController";

export class NewsItemRelocate extends NewsItem {
    private static readonly RELOCATE_TEXT = "YOU'VE BEEN RELOCATED TO A\nDIFFERENT BUILDING DUE TO\nNON-COMPLIANCE WITH RENTER'S\nQUEST RULES";
    private static readonly LEARN_MORE_TEXT = 'LEARN MORE';

    private readonly newsController: ILatestNewsController;

    private relocateText: Text;
    private learnMoreButton: TextWithUnderline;

    public constructor(id: string, newsResources: LatestNewsResourcePackage, newsController: ILatestNewsController, options: NewsItemRelocateOptions) {
        super(id, newsResources, newsResources.assets_views_latest_news_news_tooltip_pink_png, newsResources.assets_views_latest_news_news_relocate_png);
        this.newsController = newsController;
        this.build(options);
        this.layout();
    }

    private build(options: NewsItemRelocateOptions): void {
        this.relocateText = new Text(NewsItemRelocate.RELOCATE_TEXT, new NewsTextStyle());
        this.addChild(this.relocateText)
        if (!options.withInsurance) {
            this.learnMoreButton = new TextWithUnderline(NewsItemRelocate.LEARN_MORE_TEXT, new NewsTextStyle(), 0, -12, 3);
            this.learnMoreButton.eventMode = 'static';
            this.learnMoreButton.on("pointerdown", this.onLearnMoreClickHandle, this);
            this.addChild(this.learnMoreButton);
        }
    }

    private async onLearnMoreClickHandle(): Promise<void> {
        this.learnMoreButton.eventMode = 'auto';
        await this.newsController.updateLatestNewsInfo(this.id);
        await this.newsController.showRenterPolicy();
        this.learnMoreButton.eventMode = 'static';
    }

    private layout(): void {
        this.relocateText.position.set(277, 29);
        this.learnMoreButton?.position.set(430, 158);
    }

    public override destroy(options?: boolean | IDestroyOptions): void {
        this.learnMoreButton?.off("pointerdown", this.onLearnMoreClickHandle, this);
        super.destroy(options);
    }
}

export class NewsItemRelocateOptions implements INewsItemOptions {
    public readonly withInsurance: boolean;

    public constructor(withInsurance: boolean) {
        this.withInsurance = withInsurance;
    }
}
